import {VGLawCookie} from "vglawcookie";

let lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
		Vegas.counter();
		Vegas.inputMask();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		$('.vg-nav').vegasMenu({
			afterClickLink: function () {
				$('.vg-nav-hamburger, .vg-nav-sidebar, .vg-nav-overlay').removeClass('show');
			}
		});

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			let $target = $(this).data('modal'),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false;

			if(title) {
				$($target).find('.modal-title').text(title);
			}

			if(id) {
				$($target).find('form input[name=id]').val(id);
			}

			$($target).modal('show');

			return false;
		});

		$('[data-fancybox]').fancybox({
			media : {
				youtube : {
					params : {
						autoplay : 1
					}
				}
			}
		});
	},

	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},

	carousel: function () {
		OwlVegas.init('owl-carousel');
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-hdr'),
			scroll = $self.scrollTop();

		if (scroll > 0) {
			$body.addClass('vg-hdr--is-scroll');
			$sticky.addClass('is-hide-top');

			if (scroll > 93) {
				$sticky.addClass('is-hide-bottom');

				if (scroll > lastScrollTop) {
					$sticky.removeClass('is-fixed');
					$body.removeClass('vg-hdr--is-fixed');
				} else {
					$sticky.addClass('is-fixed');
					$body.addClass('vg-hdr--is-fixed');
				}

				lastScrollTop = scroll;
			} else {
				$sticky.removeClass('is-hide-bottom');
			}

		} else {
			$sticky.removeClass('is-hide-top is-hide-bottom is-fixed');
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}
	},

	counter: function () {
		$('.counter').each(function() {
			let $this = $(this),
				countTo = $this.attr('data-count');

			$({ countNum: $this.text()}).animate({
					countNum: countTo
				},{
					duration: 3000,
					easing:'linear',
					step: function() {
						$this.text(Math.floor(this.countNum));
					},
					complete: function() {
						$this.text(this.countNum);
					}
				});
		});
	},

	inputMask: function () {
		$('.input-mask-phone').inputmask('+7 (999) 999-99-99')/*.on('paste', function (e) {
			$(this).val(normalize_phone_inputmask(e.originalEvent.clipboardData.getData('text')));
			return false;
		}).on('change', function () {
			$(this).val(normalize_phone_inputmask($(this).val()));
		})*/;
	}
};
